var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnboardingVector2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 72,
    viewBox: "0 0 99 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.1669 26.0263C45.6284 -7.3593 -15.9617 -4.81145 -35.4748 12.8244C-54.9879 30.4603 -28.5104 49.5708 23.8422 82.0364C76.1948 114.502 125.59 67.7584 81.1669 26.0263Z",
    fill: "#EBF3FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingVector2);
export default __webpack_public_path__ + "static/media/onboarding-vector-2.e5efda35.svg";
export { ForwardRef as ReactComponent };